<div class="pending-page">
  <mat-card class="pending-card">
    <mat-icon class="icon">mark_email_unread</mat-icon>
    <h2>Check your email</h2>
    <p>Enter your account's email address and we'll send (or resend) a verification link.</p>
    <p class="hint">Click the link to activate your account, then log in.</p>

    <form [formGroup]="emailForm" (ngSubmit)="resend()" class="email-form">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email address</mat-label>
        <input matInput formControlName="email" placeholder="you@example.com" type="email" />
        <mat-error *ngIf="emailForm.get('email')?.hasError('required')">Email is required</mat-error>
        <mat-error *ngIf="emailForm.get('email')?.hasError('email')">Enter a valid email</mat-error>
      </mat-form-field>

      <button mat-raised-button color="primary" type="submit" [disabled]="!emailForm.valid || resending" class="full-width">
        @if (resending) {
          <mat-spinner diameter="18" class="inline-spinner"></mat-spinner>
        } @else if (resent) {
          Link sent — check your inbox
        } @else {
          Send verification link
        }
      </button>
    </form>

    <a routerLink="/landing" class="back-link">Back to login</a>
  </mat-card>
</div>
